import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { refreshPricingInventory } from "@src/store/pricing/refreshPricingInventory";

const initialState = false;
export interface IListingToUpdate {
	ListingId: string;
	NumGroups: string;
}

export const { thunk: updateSplitListingAdvanced, slice: updateSplitListingAdvancedSlice } = getThunkAndSlice<
	IListingToUpdate,
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/SplitListingAdvanced",
	method: "post",
	onAfterRequest: async (data, _params, _state, dispatch) => {
		dispatch(refreshPricingInventory());
		return data;
	},
});
